import React from 'react'
import { NavLink } from 'react-router-dom';

const StartTrialBtn = ({ title, href }) => {
  return (
    <NavLink to={href} className="startTrial-button">{title}</NavLink>
  )
}

export default StartTrialBtn